import { KEY_ICONS } from "./components";

export const EMPTY_KEY = {
	keyValue: "",
	keyPressed: false,
	keyFit: false,
	keyIcon: null,
	keyId: null,
};

export const CLEAR_KEY = {
	...EMPTY_KEY,
	keyIcon: KEY_ICONS.CLEAR,
	keyId: 11,
	keyValue: "Clear",
};

export const ENTER_KEY = {
	...EMPTY_KEY,
	keyIcon: KEY_ICONS.ENTER,
	keyId: 12,
	keyValue: "Submit",
};

export const BACKSPACE_KEY = {
	...EMPTY_KEY,
	keyId: 13,
	keyValue: "BACKSPACE",
};

// Maximum number of tries allowed per level, indexed by currentLevelIndex (0-based).
// Level 1 (starting): 5 tries, Level 2: 4 tries, Level 3: 3 tries, Level 4: 2 tries, Level 5 (last): 1 try.
export const MAX_TRIES_PER_LEVEL = [5, 4, 3, 2, 1];
